import { useState } from "react";
import { es } from "date-fns/locale";
import { CalendarBlank } from "@phosphor-icons/react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const pad = (n) => String(n).padStart(2, "0");
const toYMD = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const display = (v) => {
  if (!v) return "";
  const [y, m, d] = v.split("-");
  return `${d}/${m}/${y}`;
};

// Selector de fecha en español. Almacena/recibe el valor como string "YYYY-MM-DD"
// y lo muestra como dd/mm/aaaa.
export function DateField({ value, onChange, placeholder = "dd/mm/aaaa", testid, disabled }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          disabled={disabled}
          className={cn(
            "flex h-10 w-full items-center justify-between rounded-md border border-[#E2E8F0] bg-white px-3 text-sm text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0F172A] disabled:opacity-50",
            !value && "text-[#94A3B8]"
          )}
        >
          {value ? display(value) : placeholder}
          <CalendarBlank size={16} className="text-[#64748B]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={es}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            if (d) onChange(toYMD(d));
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
